const imagesLoaded = (parent_element, callback) => {
    let loadedCount = 0;
    let imageList = parent_element.querySelectorAll('img')
    const imageCount = imageList.length;
   
    imageList.forEach((image) => {
        image.addEventListener('load', (event) => {
            loadedCount++;
            //console.log(event.target.alt + ' loaded!');
      
          if (loadedCount === imageCount) {
            //console.log('All images loaded');
            // Call the callback after all images are loaded
            callback(imageList); 
          }
        });
    });
};

export default imagesLoaded;